import {DATA_CONSTANTS} from "../constants/data-constants";
// import wallets from "../containers/welcome/header/authenticated/wallets";

const AuthenticationStates = {
    popularGames: [],
    popularGamesDone: false,
    liveCasinoGames: [],
    liveCasinoGamesDone: false,
    sportsbookGames: [],
    sportsbookGamesDone: false,
    highRtpGames: [],
    newGames: [],
    newGamesDone: false,
    highRtpGamesDone: false,
    slidersR: [],
    scriptsR: [],
    vipStatesR: [],
    faqR: [],
    blogR: [],
    promotionsR: [],
    miniSlidersR: [],
    providerList: [],
    miniBannersR: [],
    miniGames: [],
    gameTypes: [
        {
            key: 'lobby',
            icon: 'slots',
            path: '/casino/group/lobby'
        },
        {
            key: 'popular-games',
            icon: 'popular',
            path: '/casino/group/popular-games'

        },
        {
            key: 'new-releases',
            icon: 'last-released',
            path: '/casino/group/new-releases'
        },
        {
            key: 'free-spins',
            icon: 'freespin',
            path: '/casino/group/free-spins'
        },
        {
            key: 'enhanced-rtp',
            icon: 'icon-enhanced-rtp',
            path: '/casino/group/enhanced-rtp'
        },
        {
            key: 'instant-win',
            icon: 'instant-win',
            path: '/casino/group/instant-win'
        },
        {
            key: 'jackpot-games',
            icon: 'jackpots',
            path: '/casino/group/jackpot-games'
        },
        {
            key: 'bonus-buy',
            icon: 'buy-bonus',
            path: '/casino/group/bonus-buy'
        },

    ],
    liveCasinoTypes: [
        {
            key: 'live-lobby',
            icon: 'live-lobby',
            path: '/casino/group/live-lobby'
        },

        {
            key: 'table-games',
            icon: 'table-games',
            path: '/casino/group/table-games'
        },

        {
            key: 'roulette',
            icon: 'roulette',
            path: '/casino/group/roulette'
        },

        {
            key: 'baccarat',
            icon: 'baccarat',
            path: '/casino/group/baccarat'
        },

        {
            key: 'blackjack',
            icon: 'blackjack',
            path: '/casino/group/blackjack'
        },

        {
            key: 'poker',
            icon: 'poker',
            path: '/casino/group/poker'
        },

    ],
    sportsbookTypes: [
        {
            key: 'live-betting',
            icon: 'live',
            path: '/sportsbook/live-betting'
        },

        {
            key: 'upcoming',
            icon: 'upcoming',
            path: '/sportsbook/upcoming'
        },
        {
            key: 'soccer',
            icon: 'football',
            path: '/sportsbook/soccer'
        },


        {
            key: 'basketball',
            icon: 'basketball',
            path: '/sportsbook/basketball'
        },
        {
            key: 'american-football',
            icon: 'american-football',
            path: '/sportsbook/american-football'
        },
        {
            key: 'baseball',
            icon: 'baseball',
            path: '/sportsbook/baseball'
        },
        {
            key: 'tennis',
            icon: 'tennis',
            path: '/sportsbook/tennis'
        },
        {
            key: 'table-tennis',
            icon: 'table-tennis',
            path: '/sportsbook/table-tennis'
        },

        {
            key: 'volleyball',
            icon: 'volleyball',
            path: '/sportsbook/volleyball'
        },


        {
            key: 'mma',
            icon: 'mma',
            path: '/sportsbook/mma'
        },


        {
            key: 'ice-hockey',
            icon: 'ice-hockey',
            path: '/sportsbook/ice-hockey'
        },
    ],
    exclusiveGameTypes: [
        {
            key: 'casual',
            icon: 'casual',
            path: '/casino/category/casual'
        },
        {
            key: 'lottery',
            icon: 'lottery',
            path: '/casino/category/lottery'
        },

        {
            key: 'craps',
            icon: 'craps',
            path: '/casino/category/craps'
        },
        {
            key: 'fishing',
            icon: 'fishing',
            path: '/casino/category/fishing'
        },
        {
            key: 'mines',
            icon: 'mines',
            path: '/casino/category/mines'
        },
        // {
        //     key: 'virtual_sports',
        //     icon: 'virtual-sports',
        //     path: '/casino/category/virtual_sports'
        // },
        {
            key: 'scratch',
            icon: 'scratch',
            path: '/casino/category/scratch'
        },
    ],

    topGames: [],
    topGamesDone: false,

    gameShows: [],
    gameShowsDone: false,

    buyBonusGames: [],
    buyBonusGamesDone: false,


    freespinGames: [],
    freespinGamesDone: false,


    jackpotGamesDone: false,
    jackpotGames: [],

};

const authenticationReducer = (state = AuthenticationStates, action) => {
    switch (action.type) {


        case DATA_CONSTANTS.SET_POPULAR_GAMES:
            // console.log(DATA_CONSTANTS.SET_POPULAR_GAMES, action)
            return {
                ...state,
                popularGames: action?.data,
                popularGamesDone: true
            }

        case DATA_CONSTANTS.SET_SLIDERS:
            // console.log(DATA_CONSTANTS.SET_SLIDERS, action)
            return {
                ...state,
                slidersR: {
                    ...state.slidersR,
                    [action?.data?.type]: action?.data?.data
                }
            }


        case DATA_CONSTANTS.SET_SCRIPTS:
            console.log(DATA_CONSTANTS.SET_SCRIPTS, action.data)
            return {
                ...state,
                scriptsR: {
                    ...state.scriptsR,
                    [action?.data?.type]: action?.data?.data
                }
            }

        case DATA_CONSTANTS.SET_MINI_SLIDERS:
            // console.log(DATA_CONSTANTS.SET_MINI_SLIDERS, action)
            return {
                ...state,
                miniSlidersR: {
                    ...state.miniSlidersR,
                    [action?.data?.type]: action?.data?.data
                }
            }


        case DATA_CONSTANTS.SET_VIP_STATES:
            // console.log(DATA_CONSTANTS.SET_VIP_STATES, action)
            return {
                ...state,
                vipStatesR: {
                    ...state.vipStatesR,
                    [action?.data?.type]: action?.data?.data
                }
            }
        case DATA_CONSTANTS.SET_FAQS:
            // console.log(DATA_CONSTANTS.SET_FAQS, action)
            return {
                ...state,
                faqR: {
                    ...state.faqR,
                    [action?.data?.type]: action?.data?.data
                }
            }

        case DATA_CONSTANTS.SET_BLOGS:
            // console.log(DATA_CONSTANTS.SET_BLOGS, action)
            return {
                ...state,
                blogR: {
                    ...state.blogR,
                    [action?.data?.type]: action?.data?.data
                }
            }


        case DATA_CONSTANTS.SET_PROMOTIONS:
            // console.log(DATA_CONSTANTS.SET_PROMOTIONS, action)
            return {
                ...state,
                promotionsR: {
                    ...state.promotionsR,
                    [action?.data?.type]: action?.data?.data
                }
            }

        case DATA_CONSTANTS.SET_PROVIDER_LIST:
            // console.log(DATA_CONSTANTS.SET_PROVIDER_LIST, action)
            return {
                ...state,
                providerList: action?.data || []
            }


        case DATA_CONSTANTS.SET_MINI_BANNERS:
            // console.log(DATA_CONSTANTS.SET_MINI_BANNERS, action)
            return {
                ...state,
                miniBannersR: {
                    ...state.miniBannersR,
                    [action?.data?.type]: action?.data?.data
                }
            }


        case DATA_CONSTANTS.SET_BUY_BONUS_GAMES:
            // console.log(DATA_CONSTANTS.SET_BUY_BONUS_GAMES, action)
            return {
                ...state,
                buyBonusGames: action?.data,
                buyBonusGamesDone: true
            }

        case DATA_CONSTANTS.SET_MINI_GAMES:
            // console.log(DATA_CONSTANTS.SET_MINI_GAMES, action)
            return {
                ...state,
                miniGames: action?.data
            }

        case DATA_CONSTANTS.SET_HIGH_RTP_GAMES:
            // console.log(DATA_CONSTANTS.SET_HIGH_RTP_GAMES, action)
            return {
                ...state,
                highRtpGames: action?.data,
                highRtpGamesDone: true
            }

        case DATA_CONSTANTS.SET_GAME_SHOWS:
            // console.log(DATA_CONSTANTS.SET_GAME_SHOWS, action)
            return {
                ...state,
                gameShows: action?.data,
                gameShowsDone: true
            }

        case DATA_CONSTANTS.SET_NEW_GAMES:
            return {
                ...state,
                newGames: action.data,
                newGamesDone: true
            }

        case DATA_CONSTANTS.SET_LIVE_CASINO_GAMES:
            return {
                ...state,
                liveCasinoGames: action?.data,
                liveCasinoGamesDone: true
            }


        case DATA_CONSTANTS.SET_TOP_GAMES:
            // console.log(DATA_CONSTANTS.SET_TOP_GAMES, action)
            return {
                ...state,
                topGames: action?.data,
                topGamesDone: true
            }

        case DATA_CONSTANTS.SET_FREESPIN_GAMES:
            // console.log(DATA_CONSTANTS.SET_TOP_GAMES, action)
            return {
                ...state,
                freespinGames: action?.data,
                freespinGamesDone: true
            }
        case DATA_CONSTANTS.SET_JACKPOT_GAMES:
            // console.log(DATA_CONSTANTS.SET_TOP_GAMES, action)
            return {
                ...state,
                jackpotGames: action?.data,
                jackpotGamesDone: true
            }


        case DATA_CONSTANTS.SET_SPORTSBOOK_GAMES:
            // console.log(DATA_CONSTANTS.SET_SPORTSBOOK_GAMES, action)
            return {
                ...state,
                sportsbookGames: action?.data,
                sportsbookGamesDone: true
            }


        default:
            return state;

    }
};

export default authenticationReducer;
